import ServiceLogsPanel from './ServiceLogsPanel'

function ServiceLogsTab({ active }) {
  return <ServiceLogsPanel active={active} />
}

export default ServiceLogsTab
